import styled from 'styled-components';

export const Content = styled.div`
`;

export const Icon = styled.img`
  height: 90px;
  display: block;
  margin-top: 20px;
  margin: 20px auto 0px auto;
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  > img {
    cursor: pointer;
  }
`;